import RadioField from './RadioField';

export type ValueType = string | number;
export type ValuesType = ValueType | Array<ValueType>;

export type OptionType = {
	value: ValueType;
	label: string;
	disabled?: boolean;
};
export type OptionsType = Array<OptionType>;

export default RadioField;
